import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';
/** Shared by realtime without importing SDK operations into the startup path. */
export const quickReplyLibraryKey = () => ['quick-replies', sessionScope(useAuthStore.getState())] as const;
